import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Object: { input: any; output: any; }
};

export type DecodeDirectLinkInput = {
  action: Scalars['String']['input'];
  ivHex?: InputMaybe<Scalars['String']['input']>;
  param: Scalars['String']['input'];
};

export type DecodedDirectLink = {
  __typename?: 'DecodedDirectLink';
  page: Scalars['String']['output'];
  params: Scalars['Object']['output'];
};

export type Query = {
  __typename?: 'Query';
  decodeDirectLink: DecodedDirectLink;
};


export type QueryDecodeDirectLinkArgs = {
  input: DecodeDirectLinkInput;
};

export type DecodeDirectLinkQueryVariables = Exact<{
  input: DecodeDirectLinkInput;
}>;


export type DecodeDirectLinkQuery = { __typename?: 'Query', decodeDirectLink: { __typename?: 'DecodedDirectLink', page: string, params: any } };


export const DecodeDirectLinkDocument = gql`
    query DecodeDirectLink($input: DecodeDirectLinkInput!) {
  decodeDirectLink(input: $input) {
    page
    params
  }
}
    `;

export function useDecodeDirectLinkQuery(options: Omit<Urql.UseQueryArgs<DecodeDirectLinkQueryVariables>, 'query'>) {
  return Urql.useQuery<DecodeDirectLinkQuery, DecodeDirectLinkQueryVariables>({ query: DecodeDirectLinkDocument, ...options });
};